import { Title } from "@solidjs/meta";

export default function Privacy() {
  return (
    <>
      <Title>Privacy Policy - Fun Fun Function</Title>
      <div class="max-w-2xl mx-auto p-8 text-gray-700">
        <h1 class="text-3xl font-bold mb-6">Privacy Policy</h1>
        
        <p class="mb-4">
          Fun Fun Function AB operates the funfun.email newsletter service. This page informs you of our policies regarding the collection, use, and disclosure of personal data when you subscribe to our newsletter.
        </p>

        <h2 class="text-xl font-bold mt-8 mb-4">Information We Collect</h2>
        <p class="mb-4">
          We collect your email address when you voluntarily subscribe to our newsletter. We may also collect information about how you interact with our emails, such as whether you open them and which links you click.
        </p>

        <h2 class="text-xl font-bold mt-8 mb-4">How We Use Your Information</h2>
        <p class="mb-4">
          We use your email address to send you the Fun Fun Function newsletter and related communications. We may also use aggregate data to analyze and improve our service.
        </p>

        <h2 class="text-xl font-bold mt-8 mb-4">Data Storage and Security</h2>
        <p class="mb-4">
          Your email address is stored securely with Customer.io, our email service provider. We implement appropriate security measures to protect your personal information.
        </p>

        <h2 class="text-xl font-bold mt-8 mb-4">Your Rights</h2>
        <p class="mb-4">
          Under GDPR and other data protection regulations, you have the right to access, correct, or delete your personal data. You can unsubscribe from our newsletter at any time using the link in every email.
        </p>

        <h2 class="text-xl font-bold mt-8 mb-4">Contact Us</h2>
        <p class="mb-4">
          If you have any questions about this Privacy Policy, please contact us:
        </p>
        <p class="mb-4">
          Fun Fun Function AB<br />
          Tjärhovsgatan 52<br />
          Stockholm, Stockholm 11628<br />
          Sweden
        </p>
        
        <p class="mt-8 text-sm text-gray-500">
          Last updated: February 2026
        </p>
      </div>
    </>
  );
}